<div>

  <div class="kontaktdaten-toolbar">
    <mat-form-field redispatchProvideReadonly>
      <mat-label>Filter</mat-label>
      <input matInput data-qa="filter" (keyup)="applyFilter($event)" #input>
      <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
    </mat-form-field>

    <div class="buttons">
      <button matButton="filled" class="actionbutton" data-qa="create-button" (click)="createKontaktdaten()">
        <mat-icon>add</mat-icon>
        Neuer Kontaktdaten
      </button>
    </div>
  </div>

  <table [dataSource]="kontaktdatenList"
    mat-table
    class="kontaktdaten-table"
    data-qa="data-table" >

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr style="cursor: pointer" mat-row *matRowDef="let kontaktdaten; columns: columnsToDisplay"
    (click)="openKontaktdaten(kontaktdaten)"></tr>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let kontaktdaten;">{{kontaktdaten.name}}</td>
    </ng-container>

    <ng-container matColumnDef="adresse">
      <th mat-header-cell *matHeaderCellDef>Adresse</th>
      <td mat-cell *matCellDef="let kontaktdaten;">{{kontaktdaten.adresse}}</td>
    </ng-container>

    <ng-container matColumnDef="kontakte">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="2">Kontaktinformationen</th>
      <ng-container *matCellDef="let kontaktdaten;">
        <td mat-cell>
          @for (kontakt of kontaktdaten.kontakte; track kontakt) {
            {{kontakt.type}}{{kontakt.type ? ':' : ''}}<br/>
          }
        </td>
        <td mat-cell>
          @for (kontakt of kontaktdaten.kontakte; track kontakt) {
            {{kontakt.data}}<br/>
          }
        </td>
      </ng-container>
    </ng-container>

  </table>
</div>
